import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { FiltrosMultiSelect } from 'src/app/comercial/reportes/reporte-ventas/domain/reporte-ventas.request';
import { ProformaRepository } from 'src/app/proforma/domain/proforma.repository';
import { ReporteClientesAnioEtaDetalleRequest } from 'src/app/reporte-ciclo-embarque/domain/reporte-ciclo-embarque-request';
import { ItemsReporteClientesAnioEtaResumenResponse } from 'src/app/reporte-ciclo-embarque/domain/reporte-ciclo-embarque-response';
import { ReportesRepository } from 'src/app/repositorio/reportes.repository';
import { UtilService } from 'src/app/services/util.service';
import { newmetadate } from 'src/app/shared/components/datatable/domain/datatable-domain';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
    selector: 'app-reporte-comparativo-cliente-eta',
    standalone: true,
    imports: [
        CommonModule,
        SharedModule
    ],
    templateUrl: './reporte-comparativo-cliente-eta.component.html',
    styleUrl: './reporte-comparativo-cliente-eta.component.css'
})
export class ReporteComparativoClienteEtaComponent {

  constructor(
    private readonly servReportes: ReportesRepository,
    private readonly servProforma: ProformaRepository,
    private readonly util: UtilService
  ) { }

  anio01 = ''
  anio02 = ''
  seleccionardatos() {
    this.anio01 = ''
    this.anio02 = ''
    const values = this.group.value
    if (values.anio.length > 0) {
      if (values.anio.length == 2) {
        this.anio01 = values.anio[0] < values.anio[1] ? values.anio[0] : values.anio[1]
        this.anio02 = values.anio[0] > values.anio[1] ? values.anio[0] : values.anio[1]

      }
    }


    this.metadatatable2[0].title = this.anio01 == '' ? 'Año 01' : this.anio01
    this.metadatatable2[1].title = 'Teus ' + this.anio01
    this.metadatatable2[2].title = this.anio02 == '' ? 'Año 02' : this.anio02
    this.metadatatable2[3].title = 'Teus ' + this.anio02
    this.metadatatable2[4].title = 'Diferencia Clientes ' + this.anio01 + ' vs ' + this.anio02 + ' (Desatendidos)'
    this.metadatatable2[5].title = 'Teus Clientes desatendidos ' + this.anio01 + ' vs ' + this.anio02
    this.metadatatable2[6].title = 'Diferencia Clientes ' + this.anio01 + ' vs ' + this.anio02 + ' (Nuevos)'
    this.metadatatable2[7].title = 'Teus Clientes nuevos ' + this.anio01 + ' vs ' + this.anio02

    this.metadatatable[1].title = 'Cliente ' + this.anio01
    this.metadatatable[2].title = 'Teus ' + this.anio01
    this.metadatatable[3].title = 'Cliente ' + this.anio02
    this.metadatatable[4].title = 'Teus ' + this.anio02
    this.metadatatable[5].title = 'Diferencia Clientes ' + this.anio01 + ' vs ' + this.anio02
    this.metadatatable[6].title = 'Ejecutivo ' + this.anio01
    this.metadatatable[7].title = 'Ejecutivo ' + this.anio02

  }

  metadatatable: newmetadate[] = [
    { field: 'item', title: '', inputType: 'text' },
    { field: 'cliente1', title: 'Cliente 01', inputType: 'text', style: { align: 'left', justify: 'left' } },
    { field: 'teus1', title: 'Teus 01', inputType: 'text', rowFooter: 'sum' },
    { field: 'cliente2', title: 'Cliente 02', inputType: 'text', style: { align: 'left', justify: 'left' } },
    { field: 'teus2', title: 'Teus 02', inputType: 'text', rowFooter: 'sum' },
    { field: 'diferencia', title: 'Diferencia Clientes ', inputType: 'text', style: { align: 'left', justify: 'left' } },
    { field: 'ejecutivo1', title: 'Ejecutivo 01', inputType: 'text', style: { align: 'left', justify: 'left' } },
    { field: 'ejecutivo2', title: 'Ejecutivo 02', inputType: 'text', style: { align: 'left', justify: 'left' } },
  ]

  metadatatable2: newmetadate[] = [
    { field: 'anioA', title: 'Año', inputType: 'text' },
    { field: 'teusA', title: 'Teus ' + this.anio01, inputType: 'int' },
    { field: 'anioB', title: 'Año', inputType: 'int' },
    { field: 'teusB', title: 'Teus ' + this.anio02, inputType: 'int' },
    { field: 'diferencia', title: 'Diferencia', inputType: 'int' },
    { field: 'teus_diferencia_clientes', title: 'TEUS Diferencia clientes' + this.anio02, inputType: 'int' },
    { field: 'nuevos_ingresos', title: 'Nuevos INgresos' + this.anio02, inputType: 'int' },
    { field: 'teus_nuevos_ingresos', title: 'TEUS Nuevos Ingresos' + this.anio02, inputType: 'int' },
  ]

  group: FormGroup
  onInitForm() {
    this.group = new FormGroup({
      anio: new FormControl(null, null),
      regimen: new FormControl(null, null),
      lineanegocio: new FormControl(null, null)
    })
  }

  listaAnios: any[] = []
  listarAnios() {
    this.servProforma.ListarAnio('').subscribe(response => {
      // Extrae los años del response
      const anios = response.datos.result.map(item => item.anio);

      // Ordena los años de mayor a menor
      anios.sort((a, b) => b - a);

      // Construye la lista de años con el formato adecuado
      this.listaAnios = anios.map(anio => ({
        label: anio.toString(),
        value: anio.toString()
      }));
    });
  }

  parameters(type: string): any[] {
    let value: any[] = []
    const item = {

    }
    let i = 0
    this.parametros.forEach(r => {

      if (r.tipo === type) {
        if (r.nombre !== 'SERVICIO INTEGRADO LOCAL' && r.nombre !== 'SEGUROS' && r.nombre !== 'SERVICIO LOGISTICO INTEGRAL') {
          value.push(r)
        }

      }
    });

    return value
  }

  ListaRegimen: any[] = []
  ListaLineaNegocio: any[] = []
  ngOnInit(): void {

    this.listarAnios()
    this.onInitForm()
    this.ListarParametros()

    this.group.get('anio').setValue([(new Date).getFullYear().toString(), ((new Date).getFullYear() - 1).toString()])
    this.search()
  }

  parametros: any[] = []
  async ListarParametros() {
    this.parametros = await this.util.getParametros()
    this.ListaRegimen = this.parameters('RGM')
    this.ListaLineaNegocio = this.parameters('LNG')
  }
  dataTable: any[] = []
  indicadores: ItemsReporteClientesAnioEtaResumenResponse[] = []
  preload: boolean = false
  search() {
    this.seleccionardatos()
    const request = <ReporteClientesAnioEtaDetalleRequest>{}
    const anios: FiltrosMultiSelect[] = []
    const values = this.group.value

    if (values.anio) {
      values.anio.forEach(r => {
        const item: FiltrosMultiSelect = {
          filt_codigoint: parseInt(r),
          filt_codigovar: '',
          filt_nombre: ''
        }
        anios.push(item)
      });
    }

    request.anio = anios
    request.regimen = values.regimen ? values.regimen.nombre : ''
    request.lineanegocio = values.lineanegocio ? values.lineanegocio.nombre : ''


    this.dataTable = []
    this.indicadores = []

    this.preload = true
    request.tiporeporte = 2
    this.servReportes.ReporteClientesAnioEtaDetalle(request).subscribe(response => {
      this.dataTable = response.datos.result
      let i = 1
      this.dataTable = this.dataTable.map(r => {
        return {
          ...r,          // Mantiene todas las propiedades existentes
          item: i++      // Agrega o actualiza la propiedad `item`
        };
      });
      this.preload = false
    }, (errorServicio) => {
      this.dataTable = []
      this.preload = false
    })

    request.tiporeporte = 1

    this.servReportes.ReporteClientesAnioEtaResumen(request).subscribe(response => {
      this.indicadores = response.datos.result
    })

  }
}
